export const getPrviousBalance = payload => ({
  type: 'PREV_BALANCE',
  payload,
});

export const setPreviousBalance = payload => ({
  type: 'SET_BALANCE',
  payload,
});

export const getBillDetails = payload => ({
  type: 'GET_BILL_DETAIL',
  payload,
});

export const setBillDetails = data => ({
  type: 'SET_BILL_DETAILS',
  data,
});

export const getBillTransactions = payload => ({
  type: 'GET_BILL_TRANSACTION',
  payload,
});

export const setBillTransactions = data => ({
  type: 'SET_BILL_TRANSACTION',
  data,
});

export const getBillPenalties = payload => ({
  type: 'GET_BILL_PENALTIES',
  payload,
});

export const setBillPenalties = data => ({
  type: 'SET_BILL_PENALTIES',
  data,
});

export const getPaymentList = payload => ({
  type: 'PAYMENT_LIST',
  payload,
});

export const getCurrentBalance = payload => ({
  type: 'GET_CURRENT_BALANCE',
  payload,
});

export const setCurrentBalance = data => ({
  type: 'SET_CURRENT_BALANCE',
  data,
});

export const clearBillStore = () => ({
  type: 'RESET_BILL_DETAILS',
});

export const getVirtualAccDetails = () => ({
  type: 'VIRTUAL_ACC_DETAIL',
});

export const setAccountDetails = data => ({
  type: 'SET_ACC_DETAILS',
  data,
});

export const pdfCsvExcelDownload = payload => ({
  type: 'PDF-CSV-XLS',
  payload,
  loader: true,
});
